import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		transLogin: Yup.string().required(t("fill_required_fields")),
		transPassword: Yup.string().required(t("fill_required_fields")),
	});
};
